// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import axios from 'axios';
import AsyncComputed from 'vue-async-computed';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-awesome/icons';
import Icon from 'vue-awesome/components/Icon';
import './assets/font.css';
import App from './App';
import router from './router';
import i18n from './i18n/i18n';
import { store } from './store/store';

Vue.config.productionTip = false;

Vue.use(AsyncComputed);
Vue.use(BootstrapVue);
Vue.component('v-icon', Icon);

Vue.prototype.$http = axios;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  render: h => h(App),
  store,
});



// WEBPACK FOOTER //
// ./src/main.js